import i18n from '@/locales';
import { localRead } from '@/libs/util';
import config from '@/config';
import { getSplitLinkInfo } from '@/api/chat/splitLink';
import { getField, updateField } from '@/libs/vuexHelper';
import { cloneDeep } from 'lodash';

interface SplitLinkForm {
    channel: Chat.channel; // 渠道
    split_type: 'group' | 'phone'; // 分流对象
    link_name: string; // 名称
    associate_account: string[]; // 分流账号
    split_method_switch: '0' | '1'; // 分流规则 0-随机 1-时间段
    split_time_configure: any; // 分流时间段设置
    prologue: string; // 默认开场白
    link_params: string; // 分流参数
}

interface SplitTimePartItem {
    id: string;
    clock: string[];
    accounts: string[];
    keys: string[];
}

interface SplitTimeItem {
    id: string;
    weekdays: number[];
    part: SplitTimePartItem[];
}

interface SplitTimeConfigureForm {
    default: {
        accounts: string[];
        keys: string[];
    };
    time: SplitTimeItem[];
}

const getInitSplitLinkForm = (): SplitLinkForm => {
    const isZH = ['zh-CN', 'zh-TW'].includes(i18n.locale);
    return {
        channel: (localRead(config.splitListChannelKey) || '7') as any,
        split_type: 'phone',
        link_name: `${isZH ? '分流链接' : 'SplitLink'}-${Date.now()}`,
        associate_account: [],
        split_method_switch: '0',
        split_time_configure: null,
        prologue: '',
        link_params: '',
    };
};

const getSplitTimeItem = (): SplitTimeItem => {
    return {
        id: Date.now().toString(),
        weekdays: [],
        part: [
            {
                id: `part_${Date.now().toString()}`,
                clock: [],
                accounts: [],
                keys: [],
            },
        ],
    };
};

const getInitSplitTimeConfigureForm = (): SplitTimeConfigureForm => {
    return {
        default: {
            accounts: [],
            keys: [],
        },
        time: [getSplitTimeItem()],
    };
};

interface IState {
    operationType: 'add' | 'edit';
    splitLinkForm: SplitLinkForm;
    splitTimeConfigureForm: SplitTimeConfigureForm;
}

interface IStoreModule {
    namespaced: boolean;
    state: IState;
    getters: any;
    mutations: any;
    actions: any;
}

export default {
    namespaced: true,
    state: {
        operationType: 'add', // add | edit
        splitLinkForm: getInitSplitLinkForm(),
        splitTimeConfigureForm: getInitSplitTimeConfigureForm(),
    },
    getters: {
        getField,
        selectAssociateAccountChannel: (state: any) => state.splitLinkForm.channel || '7',
        selectAssociateAccountSplitType: (state: any) => state.splitLinkForm.split_type || 'phone',
    },
    mutations: {
        updateField,
        setOperationType(state: any, type: 'add' | 'edit') {
            state.operationType = type;
        },
        setSplitLinkForm(state: any, form: SplitLinkForm) {
            state.splitLinkForm = form;
        },
        setSplitTimeConfigureForm(state: any, form: SplitTimeConfigureForm) {
            state.splitTimeConfigureForm = form;
            state.splitLinkForm.split_time_configure = form;
        },
        initSplitTimeConfigureForm(state: any) {
            if (state.splitLinkForm.split_time_configure) {
                state.splitTimeConfigureForm = cloneDeep(state.splitLinkForm.split_time_configure);
            } else {
                state.splitTimeConfigureForm = getInitSplitTimeConfigureForm();
            }
        },
        addSplitTimeItem(state: any) {
            state.splitTimeConfigureForm.time.push(getSplitTimeItem());
        },
    },
    actions: {
        getSplitLinkDetail({ commit }: any, { type = 'add', id = '' }: { type: 'add' | 'edit', id: string }) {
            commit('setOperationType', type);
            return new Promise((resolve, reject) => {
                if (type === 'add') {
                    const res = getInitSplitLinkForm();
                    commit('setSplitLinkForm', res);
                    resolve(res);
                } else {
                    getSplitLinkInfo({ id }).then((res) => {
                        const { data } = res.data;
                        const form: SplitLinkForm = {
                            channel: data.channel,
                            split_type: data.split_type,
                            link_name: data.link_name,
                            associate_account: [],
                            split_method_switch: data.split_method_switch ? data.split_method_switch : '0',
                            split_time_configure: null,
                            prologue: data.prologue || '',
                            link_params: data.link_params || '',
                        };
                        if (data.associate_account) {
                            try {
                                const associate_account = JSON.parse(data.associate_account);
                                if (Array.isArray(associate_account)) {
                                    form.associate_account = associate_account;
                                } else {
                                    form.associate_account = [];
                                }
                            } catch (e) {
                                console.error(e);
                                form.associate_account = [];
                            }
                        }
                        if (form.split_method_switch === '1' && data.split_time_configure) {
                            try {
                                form.split_time_configure = JSON.parse(data.split_time_configure);
                            } catch (e) {
                                console.error(e);
                                form.split_time_configure = null;
                            }
                            form.associate_account = [];
                        }
                        commit('setSplitLinkForm', form);
                        resolve(form);
                    }).catch((err) => {
                        console.error(err);
                        const res = getInitSplitLinkForm();
                        commit('setSplitLinkForm', res);
                        reject(err);
                    });
                }
            });
        },
    },
};
